import script from "./ReceitasPorPeriodo.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasPorPeriodo.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasPorPeriodo.vue?vue&type=style&index=0&id=d83201b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d83201b6"]])

export default __exports__